import React from 'react';
import PropTypes from 'prop-types';
import { currencyIconName, currencySymbol, STOPS_VALUE_TYPES } from 'v2/common/constants/index.js';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';
import { LocaleUtils } from '../utils/zeequantConstants';

const propTypes = {
  valueType: PropTypes.string.isRequired,
  onValueTypeChange: PropTypes.func.isRequired,
  isShowPrice: PropTypes.bool,
  isShowPoints: PropTypes.bool,
  isShowPercent: PropTypes.bool
};

const defaultProps = { isShowPrice: true, isShowPoints: true, isShowPercent: true };

const isCrypto = LocaleUtils().isCrypto();

const ValueTypeToggleBtn = ({
  valueType, onValueTypeChange, isShowPrice, isShowPoints, isShowPercent
}) => {
  const { Percent, Amount, Points } = STOPS_VALUE_TYPES;

  const toggleOptions = [
    {
      label: '%',
      value: Percent,
      shouldShow: isShowPercent,
    },
    {
      label: '',
      value: Amount,
      shouldShow: isCrypto ? false: isShowPrice,
      iconName: `${currencyIconName}`,
    },
    {
      label: 'Pts',
      value: Points,
      shouldShow: isShowPoints,
    }
  ];

  return (
    <ToggleGroupButton
      style='semi-rounded'
      options={toggleOptions}
      defaultValue={valueType}
      onChange={(value) => onValueTypeChange(value)}
    />
  );
};

ValueTypeToggleBtn.propTypes = propTypes;
ValueTypeToggleBtn.defaultProps = defaultProps;

export default ValueTypeToggleBtn;
